import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { IDENTITY_GENDER } from '../../../../constants/identity';
import { capitalize } from '../../../../util/text';
import PillButtonGroup from '../../../../components/global/PillButtonGroup';

const propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

const IdentityGenderSelectionButtons = ({
  className,
  value = null,
  onChange,
}) => {
  const classes = classNames({
    'identity-gender-selection-toggle': true,
    [className]: !!className,
  });

  return (
    <PillButtonGroup className={classes} block>
      {Object.values(IDENTITY_GENDER).map(gender => {
        return (
          <button
            type="button"
            key={gender}
            className={classNames({
              active: value === gender,
            })}
            onClick={() => onChange(gender)}
          >
            {capitalize(gender)}
          </button>
        );
      })}
    </PillButtonGroup>
  );
};

IdentityGenderSelectionButtons.propTypes = propTypes;

export default IdentityGenderSelectionButtons;
